import productImg from '../main/product/productImg';
import productPurchase from '../main/product/productPurchase';
import { constructionAsset, constructionSafety, logisticsAsset } from '@pages/Enterprise/Solution/components/Banner/BannerImages';

export default {
  desc: 'Xe nâng cần được kiểm tra hàng ngày trước khi sử dụng để đảm bảo tình trạng hoạt động tốt. Danh mục kiểm tra bao gồm phanh đỗ, đèn chiếu sáng, mức dầu thủy lực, v.v. Nếu phát hiện bất kỳ vấn đề nào, mọi hỏng hóc cần được sửa chữa ngay lập tức. Nên để kỹ thuật viên có chuyên môn thực hiện kiểm tra kỹ lưỡng hơn ít nhất mỗi tháng một lần.\nTuy nhiên, công việc do con người thực hiện luôn tiềm ẩn sai sót, và khi số lượng thiết bị cần kiểm tra tăng lên, thời gian tiêu tốn và lỗi sai cũng tăng theo tỷ lệ tương ứng. Với công nghệ RTLS, các cảm biến gắn trên xe nâng hoặc thiết bị vận chuyển hàng hóa cho phép kiểm tra tình trạng của thiết bị theo thời gian thực. Quản lý tài sản hiệu quả trực tiếp góp phần đảm bảo an toàn và tiết kiệm chi phí.',
  keywords: 'RTLS, An toàn lao động, An toan lao dong, Quản lý tài sản, Quan ly tai san, Định vị vị trí, Dinh vi vi tri, Theo dõi vị trí, Theo doi vi tri',
  ogSite: 'Giải pháp RTLS cải thiện an toàn cho người vận hành xe nâng',
  title: 'Giải pháp RTLS cải thiện an toàn cho người vận hành xe nâng',
  ogUrl: 'https://orbro.io/vi/blog/forklift',
  ogImg: '',
  ogType: 'website',
  date: '2023-05-17',
  tag1: '#RTLS',
  tag2: '#Antoanlaodong',
  tag3: '#Quanlytaisan',
  tag4: '#Dinhvivitri #Theodoivitri',
  text: [
    {
      head: 'Kiểm tra xe nâng định kỳ',
      subHead: '',
      desc: 'Xe nâng cần được kiểm tra hàng ngày trước khi sử dụng để đảm bảo tình trạng hoạt động tốt. Danh mục kiểm tra bao gồm phanh đỗ, đèn chiếu sáng, mức dầu thủy lực, v.v. Nếu phát hiện bất kỳ vấn đề nào, mọi hỏng hóc cần được sửa chữa ngay lập tức. Nên để kỹ thuật viên có chuyên môn thực hiện kiểm tra kỹ lưỡng hơn ít nhất mỗi tháng một lần.\nTuy nhiên, công việc do con người thực hiện luôn tiềm ẩn sai sót, và khi số lượng thiết bị cần kiểm tra tăng lên, thời gian tiêu tốn và lỗi sai cũng tăng theo tỷ lệ tương ứng. Với công nghệ RTLS, các cảm biến gắn trên xe nâng hoặc thiết bị vận chuyển hàng hóa cho phép kiểm tra tình trạng của thiết bị theo thời gian thực. Quản lý tài sản hiệu quả trực tiếp góp phần đảm bảo an toàn và tiết kiệm chi phí.',
      dot: '',
    },
    {
      head: 'Hệ thống cảnh báo tiếp cận gần',
      subHead: '',
      desc: 'Xe nâng có kích thước lớn và có thể gây ra thiệt hại nghiêm trọng nếu va chạm với người hoặc vật. Do đó, điều quan trọng là người vận hành phải luôn chú ý đến xung quanh và cẩn trọng với người cũng như chướng ngại vật. Nếu phát hiện người hoặc vật cản trên đường đi, cần giảm tốc độ và di chuyển một cách cẩn thận. Đây là vấn đề càng quan trọng hơn trong các kho bãi bận rộn với nhiều hoạt động.\nTrong những trường hợp này, việc đặt biển báo để cảnh báo trực quan về các khu vực nguy hiểm vẫn là một phương pháp tốt. Tuy nhiên, đôi khi không chỉ công nhân mà cả những người khác cũng có thể không nhìn thấy hoặc bỏ qua biển báo. Việc lắp đặt hệ thống cảnh báo tiếp cận gần trong những tình huống này cũng là một giải pháp rất hiệu quả. Nếu có người hoặc vật thể đang đến gần xe nâng, hệ thống có thể phát hiện và đưa ra cảnh báo theo thời gian thực. Điều này không chỉ được theo dõi bởi người vận hành xe nâng mà còn bởi người quản lý theo thời gian thực, giúp phía quản lý tuân thủ các quy định an toàn tốt hơn.',
      dot: '',
    },
    {
      head: 'Vận hành ở tốc độ phù hợp',
      subHead: '',
      desc: 'Lái xe với tốc độ nhanh sẽ làm tăng nguy cơ tai nạn, nhưng lái quá chậm lại ảnh hưởng trực tiếp đến năng suất, do đó cũng không phải là giải pháp tốt. Cần vận hành xe nâng một cách an toàn và hiệu quả. Tuy nhiên, khi tập trung vào công việc, người vận hành có thể không tuân thủ quy định về tốc độ. Trong trường hợp đó, hệ thống RTLS có thể tự động đánh giá việc tuân thủ tốc độ và đưa ra cảnh báo.',
      dot: '',
    },
    {
      head: 'Rủi ro liên quan đến tải trọng',
      subHead: '',
      desc: 'Người vận hành cần luôn biết mình đang chở bao nhiêu trọng lượng. Nếu tải quá nặng, xe nâng có thể bị lật. Người vận hành phải vận chuyển hàng hóa trong giới hạn không gây nguy hiểm cho bản thân hoặc người khác. Tương tự, xe nâng tuyệt đối không được sử dụng để vận chuyển các vật liệu nguy hiểm. Những vật liệu này có thể bị rò rỉ, tràn đổ hoặc gây cháy, tạo ra nguy cơ an toàn nghiêm trọng cho công nhân ở gần. Hệ thống RTLS giám sát những tình huống này và cung cấp dữ liệu giúp dễ dàng dự đoán và chuẩn bị ứng phó.',
      dot: '',
    },
    {
      head: 'Rủi ro từ điểm mù',
      subHead: '',
      desc: 'Điểm mù của xe nâng thường là khu vực ngay phía sau xe. Đây có thể là một nguy cơ an toàn nghiêm trọng vì nếu có người hoặc vật cản trên đường đi của xe nâng, có thể xảy ra thương tích không lường trước. Có một vài yếu tố gây ra nguy cơ từ điểm mù. Một là xe nâng thường chở lượng hàng lớn, có thể cản trở tầm nhìn của người vận hành. Hai là xe nâng thường hoạt động ở những khu vực thiếu sáng, khiến việc quan sát phía sau trở nên khó khăn hơn nhiều. Cuối cùng, xe nâng thường xuyên dừng và khởi động, điều này cũng có thể là nguyên nhân gây ra tai nạn do điểm mù. Công nghệ RTLS có thể dự đoán một cách thông minh những tai nạn an toàn có thể xảy ra do những hạn chế về khả năng của con người.',
      dot: '',
    },
    {
      head: 'Quản lý tài sản',
      subHead: '',
      desc: 'Giải pháp RTLS cũng rất hiệu quả trong việc quản lý chính các thiết bị. Có thể theo dõi vị trí của các thiết bị cần thiết cùng một lúc, dẫn đến việc bố trí thiết bị hợp lý, từ đó giúp cải thiện đáng kể năng suất. Hoặc, các thiết bị bị đánh cắp hay thất lạc cũng có thể được theo dõi vị trí, giúp giảm thiểu các tình huống phải tạm dừng công việc. Công nghệ RTLS có thể đảm bảo hiệu quả quản lý tài sản và an toàn cho cả người vận hành xe nâng và người quản lý.',
      dot: '',
    },
  ],

  link: {
    page: 'rtls',
    numb: '2',
    product: [
      {
        text: productPurchase.purchase.worker.workerTracking.title,
        title: productPurchase.purchase.worker.workerTracking.title,
        serial: productPurchase.purchase.worker.workerTracking.serial,
        desc: 'Sản phẩm này giúp gắn thiết bị UWB lên nhân viên hoặc thiết bị, hỗ trợ theo dõi vị trí theo thời gian thực.',
        img: productImg.product.workerTracking.thumbnail,
      },
      {},
    ],
    solution: [
      {
        img: constructionAsset.thumb,
        data: 'constructionAsset',
        link: '/vi/enterprise/construction/asset',
      },
      {
        img: constructionSafety.thumb,
        data: 'constructionSafety',
        link: '/vi/enterprise/construction/safety',
      },
      {
        img: logisticsAsset.thumb,
        data: 'logisticsAsset',
        link: '/vi/enterprise/logistics/asset',
      },
    ],
  },
};
